import React from 'react';
import { ArrowRight, FileText } from 'lucide-react';

interface HeroProps {
  onChecklistClick: () => void;
}

const Hero: React.FC<HeroProps> = ({ onChecklistClick }) => {
  return (
    <section className="relative w-full pt-28 pb-4 px-4 flex justify-center bg-[#010712]">
      <div className="relative w-full max-w-[1440px] h-[85vh] min-h-[650px] flex items-center overflow-hidden bg-[#0a1220]/40 rounded-none shadow-[0_20px_50px_rgba(0,0,0,0.6)]">
        
        {/* Background Image Layer - High Visibility & Clean */}
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30 select-none pointer-events-none"
          style={{ 
            backgroundImage: 'url("https://89c7958b302f88270774a4221a06006e.cdn.bubble.io/f1768841734250x897111574655008500/Untitled%20%281920%20x%201080%20px%29.png")',
            backgroundBlendMode: 'luminosity'
          }}
        />
        
        {/* Ambient Gradient Glow representing gold wealth */}
        <div className="absolute top-1/2 left-1/4 -translate-y-1/2 -translate-x-1/2 w-96 h-96 bg-[#C5A059]/10 blur-[120px] rounded-full pointer-events-none" />

        {/* Content Container */}
        <div className="relative w-full px-6 md:px-20 z-10">
          <div className="max-w-5xl">
            {/* Main Headline */}
            <h1 className="text-4xl md:text-[5.5rem] lg:text-[6.5rem] font-bold text-white mb-10 leading-[1.0] tracking-tighter w-full">
              We turn African mines into <br />
              <span className="bg-[linear-gradient(to_right,#C5A059_0%,#E6C587_25%,#FFF2D4_50%,#E6C587_75%,#C5A059_100%)] bg-clip-text text-transparent animate-gold-shimmer">
                investable
              </span> assets.
            </h1>

            {/* Simplified Subtext */}
            <p className="text-zinc-300 text-base md:text-xl mb-12 max-w-2xl leading-relaxed font-light">
              Helping high-potential operations bridge the gap between geological reality and institutional credibility.
            </p>

            {/* Call to Action Grid - Gold Effect Button */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
              <a 
                href="https://wa.me/27839287731"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 md:gap-4 bg-[#C5A059] text-zinc-950 px-6 md:px-10 py-4 md:py-5 rounded-none font-black text-[11px] md:text-[13px] uppercase tracking-[0.1em] md:tracking-[0.2em] hover:bg-[#b08c49] transition-all group whitespace-nowrap shadow-none"
              >
                Book a Strategy Call
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </a>
              
              <button 
                onClick={onChecklistClick}
                className="flex items-center justify-center gap-3 md:gap-4 bg-[#111d30]/80 backdrop-blur-md text-white px-6 md:px-10 py-4 md:py-5 rounded-none font-bold text-[11px] md:text-[13px] uppercase tracking-[0.1em] md:tracking-[0.2em] hover:bg-[#1b2b42] transition-all whitespace-nowrap cursor-pointer"
              >
                <FileText className="w-4 h-4 text-[#C5A059]" />
                Readiness Checklist
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
